import * as React from "react";
import { Modal, Button } from "semantic-ui-react";

interface Props {
    isOpen: boolean;
    loading: boolean;

    onSubmit: () => void;
    onCancel: () => void;
}

export class ConfirmCaseCloseModal extends React.Component<Props> {
    public render() {
        return (
            <Modal open={this.props.isOpen} closeOnDimmerClick={false}>
                <Modal.Header>Close case?</Modal.Header>
                <Modal.Content>This will close the case</Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.props.onCancel} disabled={this.props.loading}>Cancel</Button>
                    <Button onClick={this.props.onSubmit} loading={this.props.loading} disabled={this.props.loading}>OK</Button>
                </Modal.Actions>
            </Modal>
        );
    }
}
